<template>
    <div>
        <div class="actions-tab in-tab snp-actions">
            <b-dropdown
                variant="link"
                class="info"
                right
                toggle-class="text-decoration-none"
                no-caret
            >
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-info"></i>
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-text>
                    <div class="info-button" @click="downloadStaticFile(2)">
                        <span>
                            Режим «Мониторинг СНП»
                            <i class="icon icon-folder"></i>
                        </span>
                    </div>
                    <div class="info-title">
                        <span>Мониторинг СНП</span>
                    </div>
                    <div class="info-text">
                        <p>
                            Данный модуль предназначен для сбора и анализа
                            данных по формам мониторинга СНП по приказу Первого
                            заместителя Премьер-Министра Республики Казахстан -
                            Министра регионального развития Республики Казахстан
                            от 24 сентября 2013 года № 239/ОД. .
                        </p>
                        <div class="info-subtitle">
                            <span>Согласование</span>
                        </div>
                        <p>
                            Раздел предназначен для наблюдения за прогрессом
                            заполнения паспортов СНП, статусов и для
                            согласования/утверждения форм.
                        </p>
                    </div>
                </b-dropdown-text>
            </b-dropdown>
            <b-dropdown
                variant="link"
                right
                toggle-class="text-decoration-none"
                no-caret
            >
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <i
                                class="icon icon-download"
                                style="color: #01ac50; margin-left: 9px"
                            ></i>
                            <span style="margin-right: 15px">Скачать</span>
                        </div>
                        <i class="icon icon-keyboard"></i>
                    </div>
                </template>
                <b-dropdown-item @click="downloadAll"
                    >Статусы заполняемости</b-dropdown-item
                >
                <!-- <b-dropdown-item @click="downloadFile">Текущая форма</b-dropdown-item> -->
            </b-dropdown>
        </div>

        <div class="filter-container">
            <div class="left-content">
                <b-dropdown
                    class="filter-dropdown"
                    variant="default"
                    ref="drop"
                >
                    <template #button-content>
                        <span class="lc">
                            <i class="icon icon-filter" /> Фильтр
                        </span>
                        <span class="rc">
                            <i class="icon icon-keyboard" />
                        </span>
                    </template>
                    <div>
                        <div class="top-content">
                            <span>Параметры фильтра</span>
                            <i
                                class="icon icon-close"
                                @click="closeFilterPanel"
                            />
                        </div>
                        <div class="filter-block">
                            <b-form-group label="Год">
                                <multiselect
                                    v-model="selectedYear"
                                    :options="yearsArray"
                                    placeholder="Выберите год"
                                    :allow-empty="false"
                                    :show-labels="false"
                                    label="name"
                                />
                            </b-form-group>
                        </div>
                        <div class="filter-block">
                            <b-form-group label="Район">
                                <multiselect
                                    v-model="selectedRegion"
                                    :options="regions"
                                    placeholder="Выберите район"
                                    :allow-empty="false"
                                    :show-labels="false"
                                    label="nameRu"
                                />
                            </b-form-group>
                        </div>

                        <div class="filter-block">
                            <b-form-group label="Сельский округ">
                                <multiselect
                                    v-model="selectedDistrict"
                                    :options="districts"
                                    placeholder="Выберите сельский округ"
                                    :allow-empty="false"
                                    :show-labels="false"
                                    label="nameRu"
                                    :disabled="isFilterActive"
                                />
                            </b-form-group>
                        </div>

                        <div class="filter-block">
                            <b-form-group label="СНП">
                                <multiselect
                                    v-model="selectedSnp"
                                    :options="selectedDistrict ? snps : []"
                                    placeholder="Выберите СНП"
                                    :allow-empty="false"
                                    :show-labels="false"
                                    label="nameRu"
                                    :disabled="isFilterActive"
                                />
                            </b-form-group>
                        </div>

                        <div class="filter-block">
                            <b-form-group label="Форма">
                                <multiselect
                                    v-model="selectedReportType"
                                    :options="[{ name: 'Все' }, ...reportTypes]"
                                    placeholder="Выберите форму"
                                    :allow-empty="false"
                                    :show-labels="false"
                                    label="name"
                                />
                            </b-form-group>
                        </div>

                        <div class="filter-block" style="margin-top: 30px">
                            <b-button variant="primary" @click="applyFilter"
                                >Применить</b-button
                            >
                            <b-button variant="secondary" @click="resetFilter"
                                >Сбросить</b-button
                            >
                        </div>
                    </div>
                </b-dropdown>
            </div>

            <div class="filter-actions">
                <b-button
                    v-if="roles.VILLAGE"
                    variant="primary"
                    :disabled="!canSendToApprove()"
                    @click="handleAction('SEND_TO_APPROVE')"
                >
                    На согласование
                </b-button>
                <b-button
                    v-if="roles.DISTRICT || roles.DISTRICT_DEPARTMENTS"
                    variant="primary"
                    :disabled="!canReconcile()"
                    @click="handleReconcile"
                >
                    Согласовать
                </b-button>
                <b-button
                    v-if="roles.REGION || roles.REGION_DEPARTMENTS"
                    variant="success"
                    :disabled="!canApprove()"
                    @click="handleApprove"
                >
                    Утвердить
                </b-button>
                <b-button
                    v-if="
                        roles.DISTRICT ||
                        roles.DISTRICT_DEPARTMENTS ||
                        roles.REGION ||
                        roles.REGION_DEPARTMENTS ||
                        roles.SUPER_ADMIN
                    "
                    variant="secondary"
                    :disabled="!canSendToReprocess()"
                    @click="handleAction('SEND_TO_REPROCESS')"
                >
                    На доработку
                </b-button>
            </div>
        </div>

        <!---------Начало грид таблицы-------------->
        <div class="table-container" v-if="!loading">
            <div class="b-table-sticky-header table-responsive-true">
                <table
                    class="table b-table table-bordered b-table-no-border-collapse"
                >
                    <thead>
                        <tr class="text-center">
                            <th colspan="1" class="th-1">
                                <b-form-checkbox
                                    v-model="checkAll"
                                    @change="handleCheckboxAllChange"
                                />
                            </th>
                            <th
                                colspan="1"
                                class="th-1"
                                @click="this.toggleCollapseAll"
                            >
                                <img
                                    v-if="collapseAll"
                                    src="./icons/open.svg"
                                    alt=""
                                />
                                <img v-else src="./icons/closed.svg" alt="" />
                            </th>
                            <th colspan="4" class="th-2">
                                {{ this.tableHeaders[0].ru }}
                            </th>
                            <th colspan="4" class="th-2">
                                {{ this.tableHeaders[1].ru }}
                            </th>
                            <th colspan="4" class="th-2">
                                {{ this.tableHeaders[2].ru }}
                            </th>
                            <th colspan="4" class="th-2">
                                {{ this.tableHeaders[3].ru }}
                            </th>
                            <th colspan="7" class="th-3">
                                {{ this.tableHeaders[4].ru }}
                            </th>
                            <th colspan="7" class="th-3">
                                {{ this.tableHeaders[5].ru }}
                            </th>
                            <th colspan="1" class="th-1" />
                        </tr>
                    </thead>

                    <tbody v-if="tableVisible && selectedRegion">
                        <template v-for="region in infoArr">
                            <!-- Первый уровень: регион -->
                            <tr
                                :key="region.catoCode"
                                style="background-color: #b0e0ff80"
                            >
                                <td colspan="1" class="text-center" />
                                <td colspan="1" class="text-center">
                                    <button
                                        type="button"
                                        class="btn btn-secondary"
                                        @click="
                                            toggleSingleRegionOpen(
                                                region.catoCode
                                            )
                                        "
                                    >
                                        <img
                                            v-if="
                                                regionsOpen.includes(
                                                    region.catoCode
                                                )
                                            "
                                            src="./icons/open.svg"
                                            alt="open"
                                        />
                                        <img
                                            v-else
                                            src="./icons/closed.svg"
                                            alt="closed"
                                        />
                                    </button>
                                </td>
                                <td colspan="12">
                                    {{
                                        region.name.ru ||
                                        region.name.kk ||
                                        region.name.en
                                    }}
                                </td>
                                <td colspan="4" />
                                <td
                                    colspan="7"
                                    style="background-color: #fff5db"
                                />
                                <td colspan="7">
                                    <div
                                        v-if="
                                            region.averageProgress !==
                                                undefined &&
                                            region.averageProgress !== null
                                        "
                                    >
                                        Среднее&nbsp;-&nbsp;{{
                                            Number(
                                                region.averageProgress
                                            ).toFixed(1)
                                        }}%
                                    </div>
                                </td>
                                <td colspan="1" class="th-1" />
                            </tr>

                            <!-- Формы региона -->
                            <template
                                v-if="regionsOpen.includes(region.catoCode)"
                            >
                                <template v-for="form in region.forms">
                                    <tr
                                        :key="
                                            region.catoCode +
                                            '-' +
                                            form.formCode
                                        "
                                    >
                                        <td colspan="1" />
                                        <td colspan="13" />
                                        <td colspan="4">
                                            {{
                                                form.name.ru ||
                                                form.name.kk ||
                                                form.name.en
                                            }}
                                        </td>
                                        <td
                                            colspan="7"
                                            style="background-color: #fff5db"
                                        />
                                        <td colspan="7">
                                            <div>
                                                {{
                                                    Number(
                                                        form.progress
                                                    ).toFixed(1)
                                                }}%
                                            </div>
                                            <b-progress
                                                v-if="form.progress"
                                                height="4px"
                                                :value="form.progress"
                                                :variant="
                                                    barVariants.find(
                                                        (bar) =>
                                                            form.progress >=
                                                            bar.value
                                                    ).variant
                                                "
                                            />
                                        </td>
                                        <td colspan="1" class="th-1" />
                                    </tr>
                                </template>

                                <!-- Второй уровень: район -->
                                <template v-for="district in region.children">
                                    <tr
                                        :key="district.catoCode"
                                        style="background-color: #e0f7ff80"
                                    >
                                        <td colspan="1" class="text-center" />
                                        <td colspan="5" class="text-right">
                                            <button
                                                type="button"
                                                class="btn btn-secondary"
                                                @click="
                                                    toggleSingleRegionOpen(
                                                        district.catoCode
                                                    )
                                                "
                                            >
                                                <img
                                                    v-if="
                                                        regionsOpen.includes(
                                                            district.catoCode
                                                        )
                                                    "
                                                    src="./icons/open.svg"
                                                    alt="open"
                                                />
                                                <img
                                                    v-else
                                                    src="./icons/closed.svg"
                                                    alt="closed"
                                                />
                                            </button>
                                        </td>
                                        <td colspan="8">
                                            {{
                                                district.name.ru ||
                                                district.name.kk ||
                                                district.name.en
                                            }}
                                        </td>
                                        <td colspan="4" />
                                        <td
                                            colspan="7"
                                            style="background-color: #fff5db"
                                        />
                                        <td colspan="7">
                                            <div
                                                v-if="
                                                    district.averageProgress !==
                                                        undefined &&
                                                    district.averageProgress !==
                                                        null
                                                "
                                            >
                                                Среднее&nbsp;-&nbsp;{{
                                                    Number(
                                                        district.averageProgress
                                                    ).toFixed(1)
                                                }}%
                                            </div>
                                        </td>
                                        <td colspan="1" class="th-1" />
                                    </tr>

                                    <!-- Формы района -->
                                    <template
                                        v-if="
                                            regionsOpen.includes(
                                                district.catoCode
                                            )
                                        "
                                    >
                                        <template
                                            v-for="form in district.forms"
                                        >
                                            <tr
                                                :key="
                                                    district.catoCode +
                                                    '-' +
                                                    form.formCode
                                                "
                                            >
                                                <td colspan="1" />
                                                <td colspan="13" />
                                                <td colspan="4">
                                                    {{
                                                        form.name.ru ||
                                                        form.name.kk ||
                                                        form.name.en
                                                    }}
                                                </td>
                                                <td
                                                    colspan="7"
                                                    style="
                                                        background-color: #fff5db;
                                                    "
                                                />
                                                <td colspan="7">
                                                    <div>
                                                        {{
                                                            Number(
                                                                form.progress
                                                            ).toFixed(1)
                                                        }}%
                                                    </div>
                                                    <b-progress
                                                        v-if="form.progress"
                                                        height="4px"
                                                        :value="form.progress"
                                                        :variant="
                                                            barVariants.find(
                                                                (bar) =>
                                                                    form.progress >=
                                                                    bar.value
                                                            ).variant
                                                        "
                                                    />
                                                </td>
                                                <td colspan="1" class="th-1" />
                                            </tr>
                                        </template>

                                        <!-- Третий уровень: СНП -->
                                        <template
                                            v-for="snp in district.children"
                                        >
                                            <tr
                                                :key="snp.catoCode"
                                                style="
                                                    background-color: #f0f8ff80;
                                                "
                                            >
                                                <td
                                                    colspan="1"
                                                    class="text-center"
                                                >
                                                    <b-form-checkbox
                                                        v-model="snp.checked"
                                                        @change="
                                                            handleSnpCheck(snp)
                                                        "
                                                    />
                                                </td>
                                                <td
                                                    colspan="9"
                                                    class="text-right"
                                                >
                                                    <button
                                                        type="button"
                                                        class="btn btn-secondary"
                                                        @click="
                                                            toggleSingleRegionOpen(
                                                                snp.catoCode
                                                            )
                                                        "
                                                    >
                                                        <img
                                                            v-if="
                                                                regionsOpen.includes(
                                                                    snp.catoCode
                                                                )
                                                            "
                                                            src="./icons/open.svg"
                                                            alt="open"
                                                        />
                                                        <img
                                                            v-else
                                                            src="./icons/closed.svg"
                                                            alt="closed"
                                                        />
                                                    </button>
                                                </td>
                                                <td colspan="4">
                                                    {{
                                                        snp.name.ru ||
                                                        snp.name.kk ||
                                                        snp.name.en
                                                    }}
                                                </td>
                                                <td colspan="4" />
                                                <td
                                                    colspan="7"
                                                    style="
                                                        background-color: #fff5db;
                                                    "
                                                />
                                                <td colspan="7">
                                                    <div
                                                        v-if="
                                                            snp.averageProgress !==
                                                                undefined &&
                                                            snp.averageProgress !==
                                                                null
                                                        "
                                                    >
                                                        Среднее&nbsp;-&nbsp;{{
                                                            Number(
                                                                snp.averageProgress
                                                            ).toFixed(1)
                                                        }}%
                                                    </div>
                                                </td>
                                                <td colspan="1" class="th-1" />
                                            </tr>

                                            <!-- Формы СНП (третий уровень) -->
                                            <template
                                                v-if="
                                                    regionsOpen.includes(
                                                        snp.catoCode
                                                    )
                                                "
                                            >
                                                <template
                                                    v-for="formsnp in snp.forms"
                                                >
                                                    <tr
                                                        :key="
                                                            snp.catoCode +
                                                            '-' +
                                                            formsnp.formCode
                                                        "
                                                    >
                                                        <td
                                                            colspan="1"
                                                            class="text-center"
                                                        >
                                                            <b-form-checkbox
                                                                v-model="
                                                                    formsnp.checked
                                                                "
                                                                :disabled="
                                                                    formCheckboxDisabled(
                                                                        formsnp,
                                                                        snp
                                                                    )
                                                                "
                                                                @change="
                                                                    handleFormCheck(
                                                                        formsnp,
                                                                        snp
                                                                    )
                                                                "
                                                            />
                                                        </td>
                                                        <td colspan="13" />
                                                        <td colspan="4">
                                                            {{
                                                                formsnp.name
                                                                    .ru ||
                                                                formsnp.name
                                                                    .kk ||
                                                                formsnp.name.en
                                                            }}
                                                        </td>
                                                        <td
                                                            colspan="7"
                                                            style="
                                                                background-color: #fff5db;
                                                            "
                                                        >
                                                            <div>
                                                                <div
                                                                    v-if="
                                                                        formsnp.status &&
                                                                        formsnp
                                                                            .status
                                                                            .value &&
                                                                        formsnp
                                                                            .status
                                                                            .value ===
                                                                            'IN_PROCESS'
                                                                    "
                                                                    class="authorHistory__status"
                                                                    :class="
                                                                        formsnp.status &&
                                                                        formsnp
                                                                            .status
                                                                            .value &&
                                                                        formsnp
                                                                            .status
                                                                            .value ===
                                                                            'IN_PROCESS'
                                                                            ? formsnp
                                                                                  .status
                                                                                  .value
                                                                            : ''
                                                                    "
                                                                >
                                                                    {{
                                                                        formsnp.status &&
                                                                        formsnp
                                                                            .status
                                                                            .name &&
                                                                        formsnp
                                                                            .status
                                                                            .name
                                                                            .ru
                                                                            ? formsnp
                                                                                  .status
                                                                                  .name
                                                                                  .ru
                                                                            : ""
                                                                    }}
                                                                </div>
                                                                <b-dropdown
                                                                    v-else
                                                                    class="authorHistory--reconciliation"
                                                                    variant="link"
                                                                    toggle-class="text-decoration-none"
                                                                    no-caret
                                                                >
                                                                    <template
                                                                        #button-content
                                                                    >
                                                                        <span
                                                                            class="authorHistory__status"
                                                                            :class="
                                                                                formsnp.status &&
                                                                                formsnp
                                                                                    .status
                                                                                    .value
                                                                            "
                                                                            @click="
                                                                                () =>
                                                                                    loadHistory(
                                                                                        formsnp,
                                                                                        snp
                                                                                    )
                                                                            "
                                                                        >
                                                                            {{
                                                                                formsnp.status &&
                                                                                formsnp
                                                                                    .status
                                                                                    .name &&
                                                                                formsnp
                                                                                    .status
                                                                                    .name
                                                                                    .ru
                                                                                    ? formsnp
                                                                                          .status
                                                                                          .name
                                                                                          .ru
                                                                                    : ""
                                                                            }}
                                                                        </span>
                                                                    </template>
                                                                    <div>
                                                                        <b-spinner
                                                                            v-if="
                                                                                historyLoading
                                                                            "
                                                                            small
                                                                            label="Small Spinner"
                                                                        ></b-spinner>
                                                                        <template
                                                                            v-else
                                                                        >
                                                                            <div
                                                                                class="authorHistory__list"
                                                                                v-if="
                                                                                    historyData.length >
                                                                                    0
                                                                                "
                                                                            >
                                                                                <div
                                                                                    v-for="item of historyData"
                                                                                    class="row authorHistory__item"
                                                                                    :key="
                                                                                        item.id
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="col-4 authorHistory__status"
                                                                                        :class="
                                                                                            item.toStatus
                                                                                        "
                                                                                    >
                                                                                        {{
                                                                                            getCurrentStatusName(
                                                                                                {
                                                                                                    reportId:
                                                                                                        item.reportId,
                                                                                                    status: item.toStatus,
                                                                                                }
                                                                                            )
                                                                                        }}
                                                                                    </div>
                                                                                    <div
                                                                                        class="col-4"
                                                                                    >
                                                                                        {{
                                                                                            item.createdBy
                                                                                        }}
                                                                                    </div>
                                                                                    <div
                                                                                        class="col-4"
                                                                                    >
                                                                                        {{
                                                                                            formatDate(
                                                                                                item.createdAt
                                                                                            )
                                                                                        }}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                v-else
                                                                                class="authorHistory__notFound"
                                                                            >
                                                                                История
                                                                                не
                                                                                найдена
                                                                            </div>
                                                                        </template>
                                                                    </div>
                                                                </b-dropdown>
                                                                <span
                                                                    v-if="
                                                                        formsnp.commentFeedId
                                                                    "
                                                                    class="icon-box"
                                                                    style="
                                                                        cursor: pointer;
                                                                        margin-left: 10px;
                                                                    "
                                                                    @click="
                                                                        handleOpenCommentModal(
                                                                            formsnp
                                                                        )
                                                                    "
                                                                >
                                                                    <img
                                                                        src="./icons/comment.svg"
                                                                        alt=""
                                                                    />
                                                                </span>
                                                            </div>
                                                        </td>

                                                        <td colspan="7">
                                                            <div>
                                                                {{
                                                                    Number(
                                                                        formsnp.progress
                                                                    ).toFixed(
                                                                        1
                                                                    )
                                                                }}%
                                                            </div>
                                                            <b-progress
                                                                v-if="
                                                                    formsnp.progress
                                                                "
                                                                height="4px"
                                                                :value="
                                                                    formsnp.progress
                                                                "
                                                                :variant="
                                                                    barVariants.find(
                                                                        (bar) =>
                                                                            formsnp.progress >=
                                                                            bar.value
                                                                    ).variant
                                                                "
                                                            />
                                                        </td>
                                                        <td
                                                            colspan="1"
                                                            class="th-1"
                                                        />
                                                    </tr>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else class="spinner">
            <b-spinner
                variant="info"
                style="width: 3rem; height: 3rem"
                label="Large Spinner"
            ></b-spinner>
        </div>
        <b-modal
            v-model="commentModalOpen"
            @hide="handleCloseCommentModal()"
            centered
            hide-header
            hide-footer
        >
            <div class="comment-modal-body">
                <div class="comment-modal-title">Добавить комментарий:</div>
                <template v-if="modalCommentItem && modalCommentItem.comments">
                    <template v-for="comm of modalCommentItem.comments">
                        <div :key="comm.id" class="comment-modal-comment">
                            <div class="comment-modal-author">
                                <span>{{ comm.createdAt.slice(0, 10) }}</span>
                                <span>{{ comm.author }}</span>
                            </div>
                            <div class="comment-modal-text">
                                {{ comm.comment }}
                            </div>
                        </div>
                    </template>
                </template>
                <b-form-textarea
                    name="comment"
                    id="comment"
                    placeholder="Добавить комментарий"
                    rows="5"
                    max-rows="5"
                    v-model="comment"
                />
            </div>
            <b-button variant="success" @click="handleSendCommentModal"
                >Отправить</b-button
            >
            <b-button variant="light" @click="handleCloseCommentModal"
                >Отменить</b-button
            >
        </b-modal>
        <c-village-passport-modal
            ref="villagePassportModal"
        ></c-village-passport-modal>
    </div>
</template>

<script>
import { MonitoringSnpApi } from "@/modules/monitoring-snp/api/MonitoringSnpApi";
import {
    APPROVED,
    APPROVED_BY_DEPARTMENTS,
    APPROVED_BY_ADDITIONAL_DEPARTMENTS,
    IN_PROCESS,
    RECONCILED,
    RECONCILED_BY_DEPARTMENTS,
    SEND_TO_APPROVE,
    SEND_TO_REPROCESS,
    ROLE_DISTRICT,
    ROLE_DISTRICT_DEPARTMENTS,
    ROLE_REGION,
    ROLE_REGION_DEPARTMENTS,
    ROLE_VILLAGE,
} from "@/modules/monitoring-snp/consts/statuses";
import CVillagePassportModal from "@/modules/monitoring-snp/components/village-passport-modal";
import moment from "moment";
import { Ax } from "@/utils";

export default {
    name: "Reconciliation",
    props: ["reportTypes", "regions", "me"],
    components: {
        "c-village-passport-modal": CVillagePassportModal,
    },
    data() {
        return {
            checkAll: false,
            collapseAll: false,
            allowAgreement: true,
            selectedRegion: null,
            districts: [],
            selectedDistrict: null,
            snps: [],
            yearsArray: [],
            selectedSnp: null,
            selectedReportType: { name: "Все" },
            selectedYear: { name: "2025" },
            loading: false,
            tableHeaders: [
                {
                    ru: "Район, город",
                },
                {
                    ru: "Сельский округ, поселок",
                },
                {
                    ru: "Сельский населенный пункт",
                },
                {
                    ru: "Форма",
                },
                {
                    ru: "Статус",
                },
                {
                    ru: "Прогресс заполнения",
                },
            ],
            roles: {
                VILLAGE: this.checkRole(ROLE_VILLAGE),
                DISTRICT_DEPARTMENTS: this.checkRole(ROLE_DISTRICT_DEPARTMENTS),
                DISTRICT: this.checkRole(ROLE_DISTRICT),
                REGION_DEPARTMENTS:
                    this.checkRole(ROLE_REGION_DEPARTMENTS) ||
                    this.checkRole("ROLE_usersnp_region_departments"),
                REGION: this.checkRole(ROLE_REGION),
                SUPER_ADMIN: this.checkRole("ROLE_SNP_ADMIN"),
            },
            allowedActions: {
                IN_PROCESS: [SEND_TO_APPROVE],
                SEND_TO_APPROVE: [SEND_TO_REPROCESS, RECONCILED_BY_DEPARTMENTS],
                SEND_TO_REPROCESS: [SEND_TO_APPROVE],
                RECONCILED_BY_DEPARTMENTS: [RECONCILED, SEND_TO_REPROCESS],
                RECONCILED: [APPROVED_BY_DEPARTMENTS, SEND_TO_REPROCESS],
                APPROVED_BY_DEPARTMENTS: [
                    APPROVED,
                    APPROVED_BY_ADDITIONAL_DEPARTMENTS,
                    SEND_TO_REPROCESS,
                ],
                APPROVED_BY_ADDITIONAL_DEPARTMENTS: [
                    APPROVED,
                    SEND_TO_REPROCESS,
                ],
                APPROVED: [],
            },
            statusColors: {
                SEND_TO_APPROVE: "#F79647",
                RECONCILED: "#2196F3",
                APPROVED: "#01AC50",
                SEND_TO_REPROCESS: "#C0504C",
                IN_PROCESS: "#6087A0",
            },
            barVariants: [
                {
                    value: 90,
                    variant: "success",
                },
                {
                    value: 50,
                    variant: "primary",
                },
                {
                    value: 30,
                    variant: "warning",
                },
                {
                    value: 15,
                    variant: "danger",
                },
                {
                    value: 0,
                    variant: "secondary",
                },
            ],
            snpOpen: false,
            districtOpen: false,
            regionOpen: false,
            regionsOpen: [],
            // getDefaultInfo вызван до прихода regions (/me/cato) — ждём их в вотчере
            waitingForRegions: false,
            tableVisible: true,
            districtMap: [],
            snpMap: {},
            infoArr: [],
            comment: "",
            commentModalOpen: false,
            selectedCommentItem: null,
            modalCommentItem: null,
            itemsToAction: [],
            progresses: {},
            averages: {},
            currentReportType: null,
            historyLoading: false,
            historyData: [],
            tableShowAll: false,
            isFilterActive: true,
            tableRegion: null,
            hostName: "",
            hierarchyList: [],
            years: [],
        };
    },
    mounted() {
        this.me.katoCodes.length === 1
            ? this.getInitialSnpInfo()
            : this.getDefaultInfo();
        this.hostName = location.hostname.split(".")[0];
        this.getHierarchyList();
        this.loadYears();
        this.loadFilterYears();
    },
    watch: {
        // regions приходят пропом асинхронно: если вкладка смонтировалась раньше,
        // фильтры по умолчанию выставляются здесь
        regions: function (regions) {
            if (this.waitingForRegions && regions?.length) {
                this.waitingForRegions = false;
                this.getDefaultInfo();
            }
        },
        selectedRegion: function () {
            this.selectedDistrict = this.selectedSnp = null;
            this.selectedRegion?.code && this.loadDistricts();
            this.isFilterActive =
                (this.selectedRegion?.code[2] === "0" &&
                    this.selectedRegion?.code[3] === "0") ||
                this.selectedRegion?.nameRu === "Все";
        },
        selectedDistrict: function () {
            this.selectedSnp = null;
            if (this.selectedDistrict?.nameRu === "Все") {
                this.snps = [];
            }
            this.selectedRegion?.code &&
                this.selectedDistrict?.code &&
                this.loadSnps();
        },
    },
    methods: {
        getDefaultInfo() {
            if (!this.regions?.length) {
                this.waitingForRegions = true;
                return;
            }
            // коды в справочнике — числа, в me.initialSnp — строки: сравниваем как строки
            let region = this.regions.find(
                (reg) =>
                    String(reg.code) ===
                    String(this.me.initialSnp.regionKatoCode)
            );
            // по области сверка пустая (бэкенд строит дерево от района) — областному
            // пользователю по умолчанию выбираем первый район вместо «Все»
            if (!region || region.nameRu === "Все") {
                region = this.regions.find((reg) => reg.nameRu !== "Все");
            }
            this.selectedRegion = region;
            this.tableRegion = region;
            this.reloadData();
        },
        loadFilterYears() {
            MonitoringSnpApi.get("/snp/api/v1/admin/years")
                .then((res) => {
                    this.yearsArray = res?.data?.map((year) => ({
                        name: year.toString(),
                    }));
                })
                .catch(() => {});
        },
        getInitialSnpInfo() {
            // регион/район/СНП пользователя восстанавливаются из me.initialSnp,
            // который родитель выводит из кода КАТО — отдельный запрос не нужен
            this.selectedRegion = this.regions.find(
                (reg) =>
                    String(reg.code) ===
                    String(this.me.initialSnp?.regionKatoCode)
            );

            MonitoringSnpApi.get("/snp/api/v1/admin/dict-kato", {
                parentId: this.selectedRegion?.id,
            })
                .then((res) => {
                    this.districts = res.data;
                    this.selectedDistrict = this.districts.find(
                        (dist) =>
                            String(dist.code) ===
                            String(this.me.initialSnp?.districtKatoCode)
                    );
                    MonitoringSnpApi.get("/snp/api/v1/admin/dict-kato", {
                        parentId: this.selectedDistrict?.id,
                    })
                        .then((res) => {
                            this.snps = res.data;

                            this.selectedSnp = this.snps.find(
                                (snp) =>
                                    String(snp.code) ===
                                    String(this.me.katoCodes[0])
                            );
                            this.selectedReportType = { name: "Все" };
                            this.reloadData();
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },
        checkRole(role) {
            if (this.me?.roles) {
                return this.me.roles.find((r) => r.includes(role));
            }
            return false;
        },
        checkRoleForCheckbox(row) {
            let roles = [];
            if (this.me?.roles) {
                if (this.me.roles.some((r) => r.startsWith(ROLE_VILLAGE))) {
                    roles = [...roles, SEND_TO_APPROVE];
                }
                if (
                    this.me.roles.some((r) =>
                        r.includes(ROLE_DISTRICT_DEPARTMENTS)
                    )
                ) {
                    roles = roles.includes(SEND_TO_REPROCESS)
                        ? [...roles, RECONCILED_BY_DEPARTMENTS]
                        : [
                              ...roles,
                              SEND_TO_REPROCESS,
                              RECONCILED_BY_DEPARTMENTS,
                          ];
                }
                if (this.me.roles.some((r) => r.startsWith(ROLE_DISTRICT))) {
                    roles = roles.includes(SEND_TO_REPROCESS)
                        ? [...roles, RECONCILED]
                        : [...roles, SEND_TO_REPROCESS, RECONCILED];
                }
                if (
                    this.me.roles.some(
                        (r) =>
                            r.includes(ROLE_REGION_DEPARTMENTS) ||
                            r.includes("ROLE_usersnp_region_departments")
                    )
                ) {
                    roles = roles.includes(SEND_TO_REPROCESS)
                        ? [
                              ...roles,
                              APPROVED_BY_DEPARTMENTS,
                              APPROVED_BY_ADDITIONAL_DEPARTMENTS,
                          ]
                        : [
                              ...roles,
                              SEND_TO_REPROCESS,
                              APPROVED_BY_DEPARTMENTS,
                              APPROVED_BY_ADDITIONAL_DEPARTMENTS,
                          ];
                }
                if (this.me.roles.some((r) => r.startsWith(ROLE_REGION))) {
                    roles = roles.includes(SEND_TO_REPROCESS)
                        ? [...roles, APPROVED]
                        : [...roles, SEND_TO_REPROCESS, APPROVED];
                }
            }

            return (
                (roles.some(
                    (role) =>
                        role !== SEND_TO_REPROCESS &&
                        (this.allowedActions[row.status] || []).includes(role)
                ) &&
                    this.me.katoCodes.includes(row.katoCode.toString()) &&
                    (row.status !== IN_PROCESS || row.progress === 100)) ||
                (this.roles.SUPER_ADMIN && row.progress === 100)
            );
        },
        checkItemsToActionStatuses(row) {
            if (this.itemsToAction.length === 0) {
                return false;
            }

            if (row.status === SEND_TO_REPROCESS || row.status === IN_PROCESS) {
                if (
                    this.itemsToAction.some(
                        (r) => r.status === SEND_TO_REPROCESS
                    ) ||
                    this.itemsToAction.some((r) => r.status === IN_PROCESS)
                ) {
                    return false;
                }
            }

            if (
                this.itemsToAction.every(
                    (r) =>
                        this.getNextAvailableStatus(r) ===
                        this.getNextAvailableStatus(row)
                )
            ) {
                return false;
            }

            return true;
        },
        loadDistricts() {
            MonitoringSnpApi.get("/snp/api/v1/admin/dict-kato", {
                parentId: this.selectedRegion.id,
            })
                .then(
                    (res) => (this.districts = [{ nameRu: "Все" }, ...res.data])
                )
                .catch(() => {});
        },
        loadSnps() {
            MonitoringSnpApi.get("/snp/api/v1/admin/dict-kato", {
                parentId: this.selectedDistrict.id,
            })
                .then((res) => (this.snps = [{ nameRu: "Все" }, ...res.data]))
                .catch(() => {});
        },
        async loadData() {
            let code;

            if (this.selectedRegion?.nameRu === "Все") {
                try {
                    code = await this.getRegionKato();
                } catch (error) {
                    this.makeToast(
                        "danger",
                        "Не удалось получить код региона",
                        "Ошибка"
                    );
                    return;
                }
            } else {
                code = this.selectedRegion?.code;
            }
            // район не выбран — грузить нечего (раньше падало на code[2])
            if (!code) {
                return;
            }
            // код района приходит числом, а ниже его разбирают посимвольно
            code = String(code);

            if (
                (code[2] === "0" && code[3] === "0") ||
                this.selectedRegion.nameRu === "Все"
            ) {
                this.regions.filter((item) => item.nameRu !== "Все");
                this.tableShowAll = true;
            } else {
                this.tableShowAll = false;
            }

            this.districtMap = {};
            this.snpMap = {};
            const filterRequest = {};
            let catoCode =
                this.selectedSnp?.code || this.selectedDistrict?.code || code;
            if (this.selectedSnp?.code) {
                catoCode = this.selectedSnp.code;
            } else if (this.selectedDistrict?.code) {
                catoCode = this.selectedDistrict.code;
            } else if (
                this.selectedRegion?.code ||
                this.selectedRegion?.nameRu === "Все"
            ) {
                catoCode =
                    this.selectedRegion?.nameRu === "Все"
                        ? code
                        : this.selectedRegion.code;
            }
            if (
                this.selectedReportType?.formCode &&
                this.selectedReportType.formCode !== "Все"
            ) {
                filterRequest.formCode = this.selectedReportType.formCode;
            }

            this.loading = true;

            MonitoringSnpApi.get(`/snp/api/v1/reconciliation/${catoCode}`, {
                formCode: filterRequest.formCode,
                year: +this.selectedYear?.name || undefined,
            })
                .then((res) => {
                    this.infoArr = this.prepareRows(res.data.data);
                    this.itemsToAction = [];
                    this.checkAll = false;
                    this.currentReportType = this.selectedReportType;
                    this.openAllRows();
                })
                .catch(() =>
                    this.makeToast(
                        "danger",
                        "По данному фильтру согласовании не существует",
                        "Ошибка"
                    )
                )
                .finally(() => (this.loading = false));
        },
        makeToast(variant = null, toastBody, title) {
            this.$bvToast.toast(toastBody, {
                title: title,
                variant: variant,
                autoHideDelay: 4000,
                solid: true,
            });
        },
        toggleCollapseAll() {
            if (this.collapseAll) {
                this.collapseAll = false;
                this.regionOpen = false;
                this.regionsOpen = [];
            } else {
                this.openAllRows();
            }
        },
        // Раскрывает все уровни: регионы, районы и СНП
        openAllRows() {
            const codes = [];
            (this.infoArr || []).forEach((region) => {
                codes.push(region.catoCode);
                (region.children || []).forEach((district) => {
                    codes.push(district.catoCode);
                    (district.children || []).forEach((snp) => {
                        codes.push(snp.catoCode);
                    });
                });
            });
            this.regionsOpen = codes;
            this.collapseAll = true;
            this.regionOpen = true;
        },
        toggleRegionOpen() {
            this.regionOpen = !this.regionOpen;
            this.collapseAll = this.regionOpen;
        },
        toggleSingleRegionOpen(code) {
            this.regionsOpen = this.regionsOpen.includes(code)
                ? this.regionsOpen.filter((item) => item != code)
                : [...this.regionsOpen, code];
        },
        toggleDistrictOpen(row) {
            row.open = !row.open;
        },
        toggleSnpOpen(row) {
            row.open = !row.open;
        },
        closeFilterPanel() {
            this.$refs.drop.hide();
        },
        async reloadData() {
            await this.loadData();
        },
        applyFilter() {
            if (
                (this.selectedSnp &&
                    this.selectedDistrict &&
                    this.selectedReportType) ||
                (this.selectedRegion?.code[2] === "0" &&
                    this.selectedRegion?.code[3] === "0") ||
                this.selectedRegion?.nameRu === "Все"
            ) {
                this.tableRegion = this.selectedRegion;
                this.reloadData();
                this.closeFilterPanel();
            } else if (
                this.selectedDistrict &&
                this.selectedDistrict.nameRu === "Все"
            ) {
                this.tableRegion = this.selectedRegion;
                this.reloadData();
                this.closeFilterPanel();
            } else {
                this.makeToast(
                    "info",
                    "Все поля должны быть заполнены",
                    "Не удалось применить фильтры"
                );
            }
        },
        resetFilter() {
            this.selectedRegion =
                this.selectedDistrict =
                this.selectedSnp =
                this.selectedReportType =
                    null;
            this.itemsToAction = [];
            this.regionOpen = false;
            this.closeFilterPanel();
        },
        canSendToReprocess() {
            const {
                DISTRICT,
                DISTRICT_DEPARTMENTS,
                REGION,
                REGION_DEPARTMENTS,
                SUPER_ADMIN,
            } = this.roles;
            const statuses = this.itemsToAction.map((item) => item.status);
            return (
                statuses.length &&
                ((DISTRICT_DEPARTMENTS &&
                    statuses.every((status) => status === SEND_TO_APPROVE)) ||
                    (DISTRICT &&
                        statuses.every(
                            (status) => status === RECONCILED_BY_DEPARTMENTS
                        )) ||
                    (REGION_DEPARTMENTS &&
                        statuses.every((status) => status === RECONCILED)) ||
                    ((REGION || REGION_DEPARTMENTS) &&
                        statuses.every(
                            (status) => status === APPROVED_BY_DEPARTMENTS
                        )) ||
                    ((REGION || REGION_DEPARTMENTS) &&
                        statuses.every(
                            (status) =>
                                status === APPROVED_BY_ADDITIONAL_DEPARTMENTS
                        )) ||
                    SUPER_ADMIN) &&
                statuses.every((status) => status !== SEND_TO_REPROCESS)
            );
        },
        canReconcile() {
            const { DISTRICT, DISTRICT_DEPARTMENTS } = this.roles;
            if (!!this.itemsToAction.length) {
                const firstItemStatus = this.getNextAvailableStatus(
                    this.itemsToAction[0]
                );
                return (
                    (firstItemStatus === RECONCILED_BY_DEPARTMENTS &&
                        DISTRICT_DEPARTMENTS) ||
                    (firstItemStatus === RECONCILED && DISTRICT)
                );
            }
            return false;
        },
        handleReconcile() {
            const status = this.getNextAvailableStatus(this.itemsToAction[0]);

            this.handleAction(status);
        },
        canSendToApprove() {
            return (
                this.itemsToAction.length &&
                this.itemsToAction.every(
                    (r) => this.getNextAvailableStatus(r) === SEND_TO_APPROVE
                )
            );
        },
        canApprove() {
            const { REGION, REGION_DEPARTMENTS } = this.roles;
            if (!!this.itemsToAction.length) {
                const firstItemStatus = this.getNextAvailableStatus(
                    this.itemsToAction[0]
                );
                return (
                    ((firstItemStatus === APPROVED_BY_DEPARTMENTS ||
                        firstItemStatus ===
                            APPROVED_BY_ADDITIONAL_DEPARTMENTS) &&
                        REGION_DEPARTMENTS) ||
                    (firstItemStatus === APPROVED && REGION)
                );
            }
            return false;
        },
        handleApprove() {
            const status = this.getNextAvailableStatus(this.itemsToAction[0]);

            this.handleAction(status);
        },
        handleAction(action) {
            const year = +this.selectedYear?.name || undefined;
            // в дереве сверок у формы может не быть id записи сверки —
            // тогда получаем его отдельным запросом по СНП и форме
            Promise.all(
                this.itemsToAction.map((item) =>
                    item.id
                        ? Promise.resolve(item.id)
                        : MonitoringSnpApi.get(
                              `/snp/api/v1/reconciliation/${item.katoCode}/${item.formCode}`,
                              { year }
                          ).then((res) => res.data.data.id)
                )
            )
                .then((ids) =>
                    MonitoringSnpApi.post(
                        "/snp/api/v1/reconciliation",
                        ids.map((id) => ({
                            reconciliationId: id,
                            status: action,
                        }))
                    )
                )
                .then(() => {
                    this.checkAll = false;
                    this.itemsToAction = [];
                    this.makeToast(
                        "success",
                        "Успешно обновлен!",
                        "Запрос обработан"
                    );
                    // перезагружаем таблицу, чтобы подтянуть новые статусы
                    this.reloadData();
                })
                .catch(() =>
                    this.makeToast(
                        "danger",
                        "Произошла ошибка на сервере",
                        "Ошибка"
                    )
                );
        },
        getComments() {
            MonitoringSnpApi.get(
                `/snp/api/v1/feed/${this.selectedCommentItem.commentFeedId}/`
            )
                .then((res) => {
                    this.modalCommentItem = res.data;
                    this.commentModalOpen = true;
                })
                .catch(() => {});
        },
        handleOpenCommentModal(item) {
            this.selectedCommentItem = item;
            if (item.commentFeedId) {
                this.getComments();
            } else {
                this.commentModalOpen = true;
            }
        },
        createCommentFeed() {
            MonitoringSnpApi.post(
                `/snp/api/v1/feed/reconciliation/${
                    this.selectedCommentItem.reconciliationId ||
                    this.selectedCommentItem.id
                }/`,
                { comment: this.comment }
            )
                .then((res) => {
                    this.selectedCommentItem.commentFeedId = res.data.id;
                    this.modalCommentItem = res.data;
                    this.comment = "";
                    this.handleCloseCommentModal();
                })
                .catch(() => {});
        },
        handleSendCommentModal() {
            if (this.selectedCommentItem.commentFeedId) {
                MonitoringSnpApi.put(
                    `/snp/api/v1/feed/${this.selectedCommentItem.commentFeedId}`,
                    { comment: this.comment }
                )
                    .then((res) => {
                        this.modalCommentItem = res.data;
                        this.comment = "";
                        this.handleCloseCommentModal();
                    })
                    .catch(() =>
                        this.makeToast(
                            "danger",
                            "Ошибка",
                            "Ошибка запроса на сервере"
                        )
                    );
            } else {
                this.createCommentFeed();
            }
        },
        handleCloseCommentModal() {
            this.commentModalOpen = false;
            this.selectedCommentItem = null;
            this.modalCommentItem = null;
        },
        // Обход всех СНП вложенной структуры (регион -> район -> СНП)
        forEachSnp(callback) {
            (this.infoArr || []).forEach((region) => {
                (region.children || []).forEach((district) => {
                    (district.children || []).forEach((snp) => callback(snp));
                });
            });
        },
        // Инициализирует реактивное поле checked на селах и их формах
        prepareRows(regions) {
            (regions || []).forEach((region) => {
                (region.children || []).forEach((district) => {
                    (district.children || []).forEach((snp) => {
                        snp.checked = false;
                        (snp.forms || []).forEach((form) => {
                            form.checked = false;
                        });
                    });
                });
            });
            return regions;
        },
        toReportId(formCode) {
            return parseInt(String(formCode).replace(/\D/g, ""), 10);
        },
        // Приводит форму СНП к плоскому виду, который ожидают
        // checkRoleForCheckbox/getNextAvailableStatus/handleAction
        toActionItem(formsnp, snp) {
            return {
                id: formsnp.reconciliationId,
                status: formsnp.status?.value || formsnp.status || IN_PROCESS,
                progress: formsnp.progress || 0,
                katoCode: formsnp.katoCode || snp.catoCode,
                formCode: formsnp.formCode,
                reportId: formsnp.reportId || this.toReportId(formsnp.formCode),
                formsnp,
            };
        },
        formCheckboxDisabled(formsnp, snp) {
            const item = this.toActionItem(formsnp, snp);
            return (
                !this.checkRoleForCheckbox(item) ||
                item.progress < 100 ||
                this.checkItemsToActionStatuses(item)
            );
        },
        handleFormCheck(formsnp, snp) {
            if (formsnp.checked) {
                this.itemsToAction.push(this.toActionItem(formsnp, snp));
            } else {
                this.itemsToAction = this.itemsToAction.filter(
                    (item) => item.formsnp !== formsnp
                );
                snp.checked = false;
                if (this.checkAll) {
                    this.checkAll = false;
                }
            }
        },
        // Чекбокс села: выбирает/снимает все доступные формы этого СНП
        handleSnpCheck(snp) {
            (snp.forms || []).forEach((formsnp) => {
                if (formsnp.checked === snp.checked) {
                    return;
                }
                if (snp.checked && this.formCheckboxDisabled(formsnp, snp)) {
                    return;
                }
                formsnp.checked = snp.checked;
                this.handleFormCheck(formsnp, snp);
            });
        },
        handleCheckboxAllChange() {
            let firstStatus = "";
            this.itemsToAction = [];
            this.forEachSnp((snp) => {
                (snp.forms || []).forEach((formsnp) => {
                    const item = this.toActionItem(formsnp, snp);
                    if (
                        !this.checkAll ||
                        !this.checkRoleForCheckbox(item) ||
                        item.progress < 100
                    ) {
                        formsnp.checked = false;
                        return;
                    }
                    const next = this.getNextAvailableStatus(item);
                    if (!firstStatus) {
                        firstStatus = next;
                    }
                    if (next === firstStatus) {
                        formsnp.checked = true;
                        this.itemsToAction.push(item);
                    } else {
                        formsnp.checked = false;
                    }
                });
                snp.checked =
                    (snp.forms || []).length > 0 &&
                    (snp.forms || []).every((form) => form.checked);
            });
        },
        openVillagePassportModal(code) {
            this.$refs.villagePassportModal.showEvent(code);
        },
        goToPassport(row) {
            this.$emit("go-to-passport", {
                regionCode: row.regionKatoCode,
                districtCode: row.districtKatoCode,
                snpCode: row.katoCode,
                selectedSnp: {
                    code: row.katoCode,
                    nameRu: row.snpNameRu,
                },
                selectedReportType: {
                    id: row.reportId,
                    name: this.reportTypes[row.reportId - 1].name,
                },
            });
        },
        loadHistory(row, snp) {
            const catoCode = snp?.catoCode || row.katoCode;
            const params = {
                year:
                    +this.selectedYear?.name ||
                    this.years[this.years.length - 1],
                formCode: row.formCode,
            };

            this.historyLoading = true;
            MonitoringSnpApi.get(
                `/snp/api/v1/reconciliation/${catoCode}/history`,
                params
            )
                .then(({ data }) => {
                    // в истории приходит formCode — дополняем reportId,
                    // который ожидает шаблон (getCurrentStatusName)
                    this.historyData = (data.data || []).map((item) => ({
                        ...item,
                        reportId: this.toReportId(item.formCode),
                    }));
                    this.historyLoading = false;
                })
                .catch(() => (this.historyLoading = false));
        },
        formatDate(date) {
            return moment(date).format("DD.MM.YYYY HH:mm");
        },
        getHierarchyList() {
            MonitoringSnpApi.get(`/snp/api/v1/instruction/all`)
                .then((res) => {
                    this.hierarchyList = res.data;
                })
                .catch(() => {
                    this.makeToast(
                        "danger",
                        "Ошибка при получении иерархии",
                        "Ошибка"
                    );
                });
        },
        getNextAvailableStatus(report) {
            const { reportId, status } = report;
            const fixedStatus =
                status === "SEND_TO_REPROCESS" ? "IN_PROCESS" : status;

            const currentStatus = this.hierarchyList?.find(
                (item) =>
                    item.status === fixedStatus && item.reportId === reportId
            );

            return currentStatus
                ? this.hierarchyList?.find(
                      (item) =>
                          item.id === currentStatus.next &&
                          item.reportId === reportId
                  )?.status
                : this.hierarchy?.find((item) => item.previous === null).status;
        },
        getCurrentStatusName(report) {
            const { reportId, status } = report;

            if (status === "SEND_TO_REPROCESS") {
                return "Отправлена на доработку";
            }

            return this.hierarchyList?.find(
                (item) => item.status === status && item.reportId === reportId
            )?.name_ru;
        },
        loadYears() {
            MonitoringSnpApi.get("/snp/api/v1/admin/years")
                .then((res) => {
                    this.years = res?.data?.sort();
                })
                .catch(() => {});
        },
        downloadAll() {
            const url = "/snp/api/v1/report/file/status";
            Ax(
                {
                    url: `${url}`,
                    method: "GET",
                    data: null,
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.token}`,
                    },
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `согласование.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    console.log("err", error);
                }
            );
        },
        downloadStaticFile(id) {
            const url = `/snp/api/v1/report/file/infoTemplate/${id}`;
            const name =
                +id === 1
                    ? "СВОД 2022-I полугодие.xlsx"
                    : "Режим Мониторинг СНП.pdf";
            Ax(
                {
                    url,
                    method: "GET",
                    data: null,
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.token}`,
                    },
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", name);
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    console.log("err", error);
                }
            );
        },
        getRegionKato() {
            return new Promise((resolve, reject) => {
                Ax(
                    {
                        url: `/api/instance/code`,
                        method: "GET",
                    },
                    (data) => {
                        resolve(data || 55 + "0000000");
                    },
                    (error) => {
                        console.error("Ошибка при получении районов:", error);
                        reject(error);
                    }
                );
            });
        },
    },
};
</script>
<style lang="scss" scoped>
img {
    cursor: pointer;
}

.spinner {
    padding-top: calc(100vh / 3.3);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #eef1f8;
}

th,
td {
    height: 50px;
}

.th-1 {
    width: 4%;
    text-align: center;
}

.th-2 {
    width: 12%;
    text-align: left;
}

.th-3 {
    width: 20%;
    text-align: left;
}

.comment-modal-body {
    .comment-modal-title {
        margin-bottom: 16px;
        font-size: 14px;
        font-weight: 700;
    }

    .comment-modal-author {
        color: #7c9db3;
        display: flex;
        gap: 13px;
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
    }

    .comment-modal-text {
        margin-top: 4px;
        border: 1px solid #bcd2e0;
        border-radius: 5px;
        padding: 5px 7px 9px 10px;
        color: #1c2a3e;

        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
    }

    textarea {
        min-width: 100%;
        background-color: #fff;
        border: 1px solid #bcd2e0;
        font-size: 12px;
        resize: none;
        border-radius: 5px !important;
        margin: 25px 0;
    }
}
.snpName {
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
}
</style>
